module.exports = __webpack_public_path__ + "h5/img/sign-in-right.55f79175.png";